import angular from 'angular';
// TODO: import stuff that you need below
import 'components/sharpr/cookies/cookiesModule';
import { loginComponent } from './loginComponent';

angular
	.module('sh.login', ['sh.auth', 'ui.router', 'sh.api', 'sh.logger', 'sh.eventTracker', 'sh.cookies'])
	.component('shLogin', loginComponent());
